<template>
    <div class="mobile-container">
        <header class="mobile-header">
            <div class="mobile-logo">
                <img style="width: 70px;height: 21px;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/ca0cdff8aec8e3c843d6902255f0040b.png" alt="">
                <img @click="drawerClick" style="width: 24px;height: 24px;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/6e48d24a786f134eeb620293e348c6f8.png" alt="">
            </div>
        </header>
        <section class="mobile-section">
            <div class="section-kiss">
                <img src="http://cdnwm.yuluojishu.com/uploads/20250723/467e16e495fcacaf422d62900a5c6980.png" alt="">
            </div>
        </section>
        <section id="kissOne" class="mobile-kissu">
            <div class="kissu-btn">
                <!-- <div class="kiss-btnimg">
                    <img src="http://cdnwm.yuluojishu.com/uploads/20250723/fce12587826018588134e14480a87983.png" alt="">
                </div> -->
                <div class="kiss-btnimg">
                    <img src="http://cdnwm.yuluojishu.com/uploads/20250723/5652471884ba4781e6dd073d20bfdfa2.png" alt="">
                </div>
            </div>
        </section>
        <section id="kissTwo" class="mobile-anmoThree">
            <img style="width: 100%;height: 100%;"
                src="http://cdnwm.yuluojishu.com/uploads/20250723/eb56b810dcda0b82c2531e4cd38b7933.png" alt="">
        </section>
        <section class="mobile-four">
            <div class="four-topBOX">
                <div class="topBOXOne">
                    <img style="width: 20px;height: 20px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/93236fc7a57aeea72b6ccb564a5a571a.png" alt="">
                    <img style="width: 56px;height: 17px;margin-left: 8px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/e4bb300f9f7532f154c83ab4afc91c3a.png" alt="">
                </div>
                <div style="text-align: left;font-size: 12px;">
                    <p style="margin: 0;margin-top: 10px;">你期待的</p>
                    <p style="margin: 0;">情侣陪伴App</p>
                    <p style="margin: 0;">是什么样子的呢?</p>
                </div>
                <div class="swiper-container"
                    style="display: flex;justify-content: space-between;width: 80%;margin: 10px 0 0 70px">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in cards" :key="index">
                            <div class="flip-container">
                                <div class="flipper">
                                    <div class="front">
                                        <div class="frontcontent">
                                            <div class="frontImg">
                                                <img style="width: 100%;height: 100%;border-radius: 50%;"
                                                    :src="item.avater" alt="">
                                            </div>
                                            <p>{{ item.title }}</p>
                                            <div class="frontContent">{{ item.desc }}</div>
                                        </div>
                                    </div>
                                    <div class="back">
                                        <div class="backContent">
                                            <div class="backToptext">
                                                <div>{{ item.date }}</div>
                                                <div class="likeCount">
                                                    <img
                                                        src="http://cdnwm.yuluojishu.com/uploads/20250723/c419496c52d2eadba26990af3d14e8e6.png" />
                                                    <span>{{ item.likes }}</span>
                                                </div>
                                            </div>
                                            <div class="subtitle">{{ item.title }}</div>
                                            <div class="exporaText">{{ item.longDesc }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="four-bottom">
                每一位用户的想法，我们都会认真聆听~请下载App体验后留下真实的想法叭
            </div>
        </section>

        <footer class="footerBox">
            <div class="foot-content">
                <div class="footertext">浙ICP备2021021692号-17</div>
                <div class="footertext" style="display: flex;align-items: center;"><img
                        style="width: 12px;height: 12px;margin-right: 10px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/a9e55415fa05a212838e3dcafbdf65d3.png"
                        alt="">19255719983</div>
                <div class="footertext">浙公网安备33010502012332号</div>
                <div class="footertext" style="display: flex;align-items: center;"><img
                        style="width: 12px;height: 12px;margin-right: 10px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/d759afca28a8ddbf3897980ea1d5bb80.png"
                        alt="">kefu@yuluojishu.com</div>
            </div>
        </footer>
        <el-drawer :visible.sync="drawer" :with-header="false" size="100%">
            <div class="drawer-content">
                <img style="width: 70px;height: 21px;margin-left: 20px;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/223207f6dd715a22f2183209fa6bdad6.png" alt="">
                <img style="width: 24px;height: 24px;margin-right: 20px;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/44eff3cce79cd18f293785fb3deb4a35.png"
                    @click="drawer = false" alt="">
            </div>
            <div class="drawerContent">
                <div class="drawerItem" @click.prevent="navigateTo('#kissOne')">
                    <a href="#kissOne" class="hover:underline">KISS定义</a>
                    <img style="width: 5px;height: 11px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/3e6646e573c748ec1c9c31215da73b68.png" alt="">
                </div>
                <img style="width: 100%;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/50f6a8923b0c9d9c16e8c79f146469e3.png" alt="">
                <div class="drawerItem" @click.prevent="navigateTo('#kissTwo')">
                    <a href="#kissTwo" class="hover:underline">KISS一下</a>
                    <img style="width: 5px;height: 11px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/5185d424f3c33a7e082ff2ecad430fce.png" alt="">
                </div>
                <img style="width: 100%;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/9ca2056976152ca3dd66c8ecabdff40a.png" alt="">
                <div class="drawerItem" @click.prevent="drawerTwoclick()">
                    <a class="hover:underline">加入我们</a>
                    <img style="width: 5px;height: 11px;"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/5185d424f3c33a7e082ff2ecad430fce.png" alt="">
                </div>
            </div>
        </el-drawer>
        <!-- 报名 -->
        <el-drawer :visible.sync="drawerBottom" direction="btt" size="60%" :with-header="false">
            <!-- <span>我来啦!</span> -->
            <div style="padding-top: 20px;">
                <img style="width: 92px;height: 27px;"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/9b849fc7f7f5b89804be0308998abdcd.png" alt="">
                <div class="joinupload" style="text-align: left;">
                    <el-button v-for="item, index in jobList" :key="index"
                        :style="{ background: jobSelse == item.value ? '#FFA9BC' : '', color: jobSelse == item.value ? '#fff' : '', margin: '10px 5px' }"
                        @click="jobSelse = item.value">{{
                            item.title
                        }}</el-button>
                    <div class="joinuploadBox">
                        <div class="joinContent">
                            <div style="display: flex;align-items: center;">你的简历<el-upload class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/" multiple
                                    style="margin-left: 20px;" :show-file-list="false">
                                    <el-button size="small" style="background: #FFA9BC;color: #fff;">点击上传</el-button>
                                </el-upload></div>
                            <div style="display: flex;align-items: center;margin-top: 20px;">你的邮箱 <el-input
                                    v-model="input" placeholder="有效邮箱" style="width: 65%;margin-left: 20px;"></el-input>
                            </div>
                            <div style="width: 100%;display: flex;justify-content: center;">
                                <el-button style="background: #FFA9BC;color: #fff;margin-top: 20px;width: 200px;"
                                    @click="sumbit()">提交</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    data() {
        return {
            drawer: false,
            drawerBottom: false,
            jobList: [
                { title: '手绘原画师', value: 1 },
                { title: '动效师', value: 2 },
                { title: 'AE剪辑师', value: 3 },
                { title: '建模师', value: 4 },
            ],
            cards: [
                { title: 'hh.', desc: '从谈到这个App的时候我们就已经开始无话不说，慢慢的越来越近，我们一起经营着这段感情，现在我们隔了很远很远，仍然时刻kiss U，这大概就是爱情的魔力吧', longDesc: '从谈到这个App的时候我们就已经开始无话不说，慢慢的越来越近，我们一起经营着这段感情，现在我们隔了很远很远，仍然时刻kiss U，这大概就是爱情的魔力吧', date: '2025.7.12', likes: 99, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/bbb57c8e63485e6d28643d90c1bfb057.png' },
                { title: '暖暖', desc: '我们是在异地恋中偶然刷到这个 App 的，一开始只是想试试，结果完全上头！每天打卡签到、互送小红花、许愿清单、纪念日提醒……每一个功能都甜到让人尖叫。我们甚至会在“情侣日记”里互写情书，把以前不敢说的情话写下来，比微信聊天有温度太多。现在打开这个 App 成了我一天中最期待的事，就像打开我们的小世界，只有我和他能进来。', longDesc: '我们是在异地恋中偶然刷到这个 App 的，一开始只是想试试，结果完全上头！每天打卡签到、互送小红花、许愿清单、纪念日提醒……每一个功能都甜到让人尖叫。我们甚至会在“情侣日记”里互写情书，把以前不敢说的情话写下来，比微信聊天有温度太多。现在打开这个 App 成了我一天中最期待的事，就像打开我们的小世界，只有我和他能进来。', date: '2025.7.12', likes: 190, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/e6ada3fd463f3ab4cc666e38f9315193.jpg' },
                { title: 'wsy', desc: '这 App 太懂女孩子的心思了，什么恋爱提醒、专属背景、情侣头像、亲密等级通通安排上了！有时候我生气不想讲话，他就用 App 里的“哄哄我”功能写道歉小纸条，一秒化解冷战哈哈哈。我们还设定了“情侣守则”，像是“每周至少发一次情话”、“生气不能超过 2 小时”，现在都变成了感情里的小默契。真的觉得，有了它，连吵架都更温柔了', longDesc: '这 App 太懂女孩子的心思了，什么恋爱提醒、专属背景、情侣头像、亲密等级通通安排上了！有时候我生气不想讲话，他就用 App 里的“哄哄我”功能写道歉小纸条，一秒化解冷战哈哈哈。我们还设定了“情侣守则”，像是“每周至少发一次情话”、“生气不能超过 2 小时”，现在都变成了感情里的小默契。真的觉得，有了它，连吵架都更温柔了', date: '2025.7.12', likes: 77, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/cda99f4c6825e406a88d3971e231c3d4.jpg' },
                { title: 'wuli胡哈哈', desc: '以前我们只是微信聊天、偶尔视频，感觉平淡得像朋友。但用了这个情侣 App 之后，每天的互动变得特别有仪式感。比如他会提前在 App 里设置我生日的惊喜倒计时，或者写个“偷偷想你”的语音便签放在留言板里。最戳心的是，我们一起写了未来旅行的愿望清单，现在每完成一个都会打勾，感觉在一起真的越来越有目标。很感谢这个 App，把我们的日常生活变成了一场浪漫电影', longDesc: '以前我们只是微信聊天、偶尔视频，感觉平淡得像朋友。但用了这个情侣 App 之后，每天的互动变得特别有仪式感。比如他会提前在 App 里设置我生日的惊喜倒计时，或者写个“偷偷想你”的语音便签放在留言板里。最戳心的是，我们一起写了未来旅行的愿望清单，现在每完成一个都会打勾，感觉在一起真的越来越有目标。很感谢这个 App，把我们的日常生活变成了一场浪漫电影', date: '2025.7.12', likes: 127, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/f5d58ee35afe2e648d9a792a77dbc51c.jpg' },
                { title: '王小帅', desc: '最喜欢这个 App 的地方，就是它帮我们记录了很多平常不会保存的“碎片时刻”：凌晨 1 点的语音告白、第一次做饭失败的合照、一起许下的 100 个小愿望……每次回看都像是翻开一本属于我们的相册，让人很有安全感。而且它比朋友圈更私密，只属于我们两个。每段感情都值得被认真对待，这个 App 就是那个帮我们“认真”的角色。', longDesc: '最喜欢这个 App 的地方，就是它帮我们记录了很多平常不会保存的“碎片时刻”：凌晨 1 点的语音告白、第一次做饭失败的合照、一起许下的 100 个小愿望……每次回看都像是翻开一本属于我们的相册，让人很有安全感。而且它比朋友圈更私密，只属于我们两个。每段感情都值得被认真对待，这个 App 就是那个帮我们“认真”的角色。', date: '2025.7.12', likes: 999, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/1df17a8a4d7d3c13eb30592113cc50bf.jpg' },
                { title: '郑进湾', desc: '用这个 App 久了，会有一种“我们不是在谈恋爱，是在养一段感情”的感觉。每天完成打卡任务、签到获取小道具、累计亲密值解锁纪念背景……好像我们是一对“恋爱搭档”，一起经营一个叫“爱情”的游戏。而且越用越上头，连我男朋友这个原本“钢铁直男”都被我带入坑了，现在他比我还主动发情侣照片。哈哈，这就是甜宠 App 的魔力吧。', longDesc: '用这个 App 久了，会有一种“我们不是在谈恋爱，是在养一段感情”的感觉。每天完成打卡任务、签到获取小道具、累计亲密值解锁纪念背景……好像我们是一对“恋爱搭档”，一起经营一个叫“爱情”的游戏。而且越用越上头，连我男朋友这个原本“钢铁直男”都被我带入坑了，现在他比我还主动发情侣照片。哈哈，这就是甜宠 App 的魔力吧。', date: '2025.7.12', likes: 999, avater: 'http://cdnwm.yuluojishu.com/uploads/20250721/e38ee98a5eba0f6010b0f8367363ea0f.jpg' },
            ],
            jobSelse: 1,
            input: '',
        }
    },
    mounted() {
        new Swiper('.swiper-container', {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true
        })
    },
    methods: {
        drawerClick() {
            this.drawer = true
        },
        navigateTo(id) {
            this.drawer = false;
            requestAnimationFrame(() => {
                const target = document.querySelector(id);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },
        drawerTwoclick() {
            this.drawer = false
            this.drawerBottom = true
        },
        sumbit() {
            if (this.input == '') {
                this.$message('邮箱不能为空');
                return;
            }
            this.$message({
                message: '提交成功',
                type: 'success'
            });
            this.drawerBottom = false
            this.input = '';
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
    color: black;
}

.mobile-container {
    max-width: 100vw;
    overflow-x: hidden;
    background-color: #fff;
    min-height: 100vh;
}

.mobile-header {
    width: 100%;
    height: 44px;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    z-index: 100;
    backdrop-filter: blur(5px);
    /* 毛玻璃效果 */
}

.mobile-logo {
    width: 90%;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5%;
}

.mobile-section {
    width: 100%;
    min-height: 243px;
    padding: 15px;
    box-sizing: border-box;
    background: url('http://cdnwm.yuluojishu.com/uploads/20250723/3ef15b63d0f3ef561e8a7dc5bcd0758a.png') no-repeat;
    background-size: 100% 100%
}

.section-kiss {
    width: 215px;
    height: 52px;
    margin-top: 110px;
}

.mobile-kissu {
    width: 100%;
    min-height: 370px;
    background: url('http://cdnwm.yuluojishu.com/uploads/20250723/60c22d07d4aa671966e2f3648e19a058.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    aign-items: center;
}

.kissu-btn {
    width: 75%;
    height: 31px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
}

.kiss-btnimg {
    width: 127px;
    height: 31px;
}

.mobile-anmoThree {
    width: 100%;
    height: 544px;
}

.mobile-four {
    width: 100%;
    min-height: 250px;
    background: url('http://cdnwm.yuluojishu.com/uploads/20250723/fb9e8541ad4e57d825e70649865b086e.png') no-repeat;
    background-size: 100% 100%;
}

.four-topBOX {
    width: 80%;
    margin: auto;
    padding-top: 27px;
}

.topBOXOne {
    display: flex;
    align-items: center;
}

.flip-container {
    perspective: 1000px;
    width: 75px;
    height: 93px;
}

.flipper {
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.6s;
}

.custom-swiper {
    width: 100%;
    padding: 10px 0;
}

.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* .divider {
    border: 1px solid #fff;
    width: 100%;
    margin: auto;
    border: 1px solid red;
}

.divider.small {
    width: 70%;
    margin-top: 40px;
} */

.likeCount {
    display: flex;
    align-items: center;
}

.likeCount img {
    width: 3px;
    height: 3px;
}

.front,
.back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: white;
}

.front {
    background: url("http://cdnwm.yuluojishu.com/uploads/20250723/d47f9241fe8d6929add772dfc296650b.png") no-repeat center center;
    background-size: 100% 100%;
}

.frontcontent {
    width: 80%;
    height: 75%;
    color: #666666;
    font-size: 5px;
}

.frontImg {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    margin: 0 auto;
}

.frontContent {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 显示3行 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 5px;
    font-size: 6px;
}

.back {
    transform: rotateY(180deg);
    background: url("http://cdnwm.yuluojishu.com/uploads/20250723/d47f9241fe8d6929add772dfc296650b.png") no-repeat center center;
    background-size: 100% 100%;
}

.backContent {
    width: 85%;
    height: 88%;
    color: #666666;
    font-size: 5px;
    text-align: left;
}

.backToptext {
    display: flex;
    justify-content: space-between;
}

.exporaText {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    /* 显示3行 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 5px;
}

.fotterBox {
    width: 87%;
    position: absolute;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 20px;
    height: 59px;
}

.fotterLeft>p {
    margin: 0;
    text-align: left;
}

.fotterRight {
    text-align: left;
}

.four-bottom {
    width: 90%;
    margin: 12px auto;
    color: #DFDFDF;
    font-size: 10px;
}

.footerBox {
    width: 100%;
    height: 49px;
    background-color: #787878;
    display: flex;
    align-items: center;
    justify-content: center;
}

.foot-content {
    width: 85%;
    margin: auto;
    height: 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: #DDDDDD;
    font-size: 10px;
}

.footertext {
    width: 45%;
    text-align: left;
    line-height: 20px;
}

.drawer-content {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.drawerContent {
    width: 90%;
    margin: 20px auto;
}

.drawerItem {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #666666;
    font-size: 16px;
    align-items: center;
}
</style>